export const TestHooks = {
	ClientsMemberCard: 'clients-member-card',
	OtherPartyClientCard: 'other-party-client-card',
	OtherPartyLawyerCard: 'other-party-lawyer-card',
	OtherPartyClerkCard: 'other-party-clerk-card',
} as const;
